import Vue from "vue";
import VueI18n from "vue-i18n";
import { Locale } from "vant";
import vantZhCN from "vant/lib/locale/lang/zh-CN";
import vantZhTW from "vant/lib/locale/lang/zh-TW";
import vantEnUS from "vant/lib/locale/lang/en-US";
import vantViVN from "vant/lib/locale/lang/vi-VN";
import zh from "./lang/zh.js";
import zhTW from "./lang/zh-TW.js";
import en from "./lang/en.js";
import Vietnamese from "./lang/Vietnamese.js";
import { normalizeUiLocale } from "./language";

Vue.use(VueI18n);

const LOCALE_KEY = "language";

const vantLocales = {
  'zh-CN': { name: 'zh-CN', messages: vantZhCN },
  'zh-TW': { name: 'zh-TW', messages: vantZhTW },
  en: { name: 'en-US', messages: vantEnUS },
  Vietnamese: { name: 'vi-VN', messages: vantViVN }
};

const locales = {
  'zh-CN': {
    ...zh
  },
  'zh-TW': {
    ...zhTW
  },
  en: {
    ...en
  },
  Vietnamese: {
    ...Vietnamese
  },

};

let langLocale = normalizeUiLocale(window.localStorage.getItem(LOCALE_KEY));
window.localStorage.setItem(LOCALE_KEY, langLocale);
const i18n = new VueI18n({
  locale: langLocale,
  messages: locales,
  silentTranslationWarn: true
});
const init = Vue.prototype._init;
Vue.prototype._init = function(options) {
  init.call(this, {
    i18n,
    ...options
  });
};

export const setup = lang => {
  langLocale = normalizeUiLocale(lang === undefined
    ? window.localStorage.getItem(LOCALE_KEY)
    : lang);
  window.localStorage.setItem(LOCALE_KEY, langLocale);

  Vue.config.lang = langLocale;
  i18n.locale = langLocale;
  const vantLocale = vantLocales[langLocale] || vantLocales['zh-CN'];
  Locale.use(vantLocale.name, vantLocale.messages);
};

setup();

export default i18n;



// WEBPACK FOOTER //
// ./src/locales/index.js